import { Link } from "react-router-dom";
import { Nav, NavItem } from "reactstrap";
import { Href } from "../../../../constants";
import { ContactOption } from "../../../../data/applications/Contacts";
import { ContactSidebarProps } from "../../../../types/Applications";
import AddContact from "./modals/addContact";
import Category from "./modals/Category";

// This component renders a sidebar menu for managing contact views and categories.
const ContactOptions: React.FC<ContactSidebarProps> = ({ activeTab, setActiveTab, changeTab }) => {

  const tabClick = (id: number) => {
    setActiveTab(id);
    changeTab(id);
  };

  return (
    <Nav className="main-menu contact-options custom-scrollbar">
      <NavItem>
        <AddContact />
      </NavItem>
      <NavItem>
        <span className="main-title">{"Views"}</span>
      </NavItem>
      <NavItem>
        <Link to={Href} className={activeTab === 1 ? "active" : ""} onClick={() => tabClick(1)}>
          <span className={`title${activeTab === 1 ? " f-w-600" : ""}`}>{"Personal"}</span>
        </Link>
      </NavItem>
      <NavItem>
        <Category />
      </NavItem>
      {/* Mapping through contactOptions to dynamically render a list of contact options as NavItems*/}
      {ContactOption.map((item) => (
        <NavItem key={item.id}>
          <Link to={Href} className={activeTab === item.id ? "active" : ""} onClick={() => tabClick(item.id)}>
            <span className={`title${activeTab === item.id ? " f-w-600" : ""}`}>{item.title}</span>
          </Link>
        </NavItem>
      ))}
    </Nav>
  );
};
export default ContactOptions;